<template>
	<div class="flex items-center">
		<div v-if="chatHeader && chatHeader.shown" class="hidden md:flex">
			<chat-header-button />
		</div>
		<app-title :title="clock" />
	</div>
</template>

<script>
	import AppTitle from '@/components/app/AppTitle';
	import ChatHeaderButton from '@/components/chat/ChatHeaderButton.vue';
	import moment from 'moment';

	export default {
		name: 'AppDigitalTime',
		components: { AppTitle, ChatHeaderButton },
		// Provided by the signed-in layout: on wide screens the header chat button sits left of the clock.
		inject: { chatHeader: { default: null } },
		data: () => ({
			clock: moment().format('HH:mm:ss'),
			clockInterval: null,
		}),
		mounted() {
			if (this.chatHeader) {
				this.chatHeader.clocks += 1;
			}
			this.clockInterval = setInterval(() => {
				this.clock = moment().format('HH:mm:ss');
			}, 1000);
		},
		beforeUnmount() {
			if (this.chatHeader) {
				this.chatHeader.clocks -= 1;
			}
			clearInterval(this.clockInterval);
		},
	};
</script>
